export const DECISION_MODEL_STEPS_CONSTANTS = {
  INITIAL_STEP: 'InitialStep',
  DECISION_STEP: 'DecisionStep',
  FINAL_STEP: 'FinalStep',
};
